import { ENV_VALUES } from '@/config/env';
import { areAllFormsCompleted } from '@/helpers/FormCompletionChecker';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);
const routes: RouteConfig[] = [
  {
    path: '/',
    name: '',
    redirect: { path: '/welcome' },
    component: () => import('../patient-app/PatientApp.vue'),
    children: [
      {
        path: '/welcome',
        name: 'welcome',
        component: () => import('../welcome/WelcomeScreen.vue'),
      },
      {
        path: '/language',
        name: 'language',
        component: () => import('../language/LanguagePicker.vue'),
      },
      {
        path: '/form-selection',
        name: 'form-selection',
        component: () => import('../form/FormSelection.vue'),
      },
      {
        path: '/form/:formId',
        name: 'form',
        props: true,
        component: () => import('../form/FormViewer.vue'),
      },
      {
        path: '/done',
        name: 'done',
        component: () => import('../form/Done.vue'),
      },
    ],
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../error/PageNotFound.vue'),
  },
  {
    path: '*',
    redirect: '/error',
    component: () => import('../error/PageNotFound.vue'),
  },
];

const router = new VueRouter({
  base: ENV_VALUES.BASE_URL,
  routes,
  scrollBehavior() {
    // on Route change, always scroll back to top
    return { x: 0, y: 0 };
  },
});

// Navigation guard: Redirect to form selection if all forms are completed
// Note: We can't prevent back navigation on mobile devices, so users can navigate back from /done
// If they do and all forms are completed, this guard redirects them to /form-selection
// (which will display all forms as completed) instead of allowing navigation to other pages (e.g., previously filled form)
router.beforeEach((to, from, next) => {
  // Don't redirect if already on the form selection or done page
  if (to.path === '/form-selection' || to.path === '/done') {
    return next();
  }

  // Check if all forms are completed
  if (areAllFormsCompleted()) {
    return next({ path: '/form-selection', query: to.query });
  }

  // Continue with normal navigation
  next();
});

export default router;

console.log('process.env', process.env);
